import { ErrorManager, MessageType } from '@react_components/errors';
import { PaymentStatusRes } from '../../../models/PaymentStatusRes';

const endPoints = {
	getStatus: '/autopay/status',
};

export const getStatus = async () => {
	try {
		const res = await fetch(endPoints.getStatus);
		return (await res.json()) as PaymentStatusRes;
	} catch (error) {
		ErrorManager.pushError({
			canClose: true,
			title: 'Błąd podczas pobierania statusu płatności',
			content:
				'Podczas pobierania statusu płatności wystąpił błąd, spróbuj ponownie później lub skontaktuj się z obsługą.',
			type: MessageType.error,
		});
	}
};
